import * as React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import styles from './index.scss';

const logo = require('./assets/logo.png');
const qrcode = require('./assets/qrcode.png');

const Footer: React.FunctionComponent = () => {
  return (
    <div className={styles.footerContainer}>
      <h2>解决方案</h2>
      <ul className={styles.solutionList}>
        <li>
          <Link to='/home/solution/contract'>电子合同</Link>
        </li>
        <li>
          <Link to='/home/solution/copyright'>版权保护</Link>
        </li>
        <li>
          <Link to='/home/solution/art'>艺术品溯源</Link>
        </li>
        <li>
          <Link to='/home/solution/medicine'>药品/保健品溯源</Link>
        </li>
        <li>
          <Link to='/home/solution/cert'>证书保全</Link>
        </li>
      </ul>
      <h2>联系我们</h2>
      <ul className={styles.contactList}>
        <li>
          <span>申请合作</span>0571-89990095
        </li>
        {/* <li>
          <span>企业电话</span>0571-89995238
        </li> */}
      </ul>
      <img className={styles.logo} src={logo} />
      <img className={styles.qrcode} src={qrcode} />
      <p>扫一扫咨询客服</p>
      <div className={styles.copyright}>
        Copyright &copy; 2016-{moment().format('YYYY')} Hangzhou Qulian Technology Co.
        <br />
        All rights reserved. 浙ICP备16033604号-1 <br />
        浙网信备 33010819963715880017 号
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.tsx